export default class Loader {

  static show(text, element) {

    if (!text)
      text = "Por favor, aguarde ..."

    if (!element)
      element = "body"

    $(element).loadingModal({
      text, 
      animation: "circle",
    })
  }

  static hide(element) {
    
    if (!element)
      element = "body"

    $(element).loadingModal("destroy")
  }
}